/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Card, Flex } from '@radix-ui/themes';

import Text from 'solis/react/primitive/text';


export default ({ sector }) =>
(
  <Card>
    <Flex direction = 'column' gap = '3'>

      <Text.Title>Sector</Text.Title>

      <Text.Note>{'Currency: ' + sector.cass.currency}</Text.Note>

    </Flex>
  </Card>
);
